import adminApi from '@/api/admin/adminClient';
import { ENDPOINTS } from '@/api/endpoints';
import type { ApiEnvelope } from '@/types/dashboard/auth';
import type { AdminKiosk, KioskPayload } from '@/types/dashboard/kiosk';

export const kioskService = {
  /** All kiosks, or only one vendor's when `vendorId` is given. */
  async list(vendorId?: number): Promise<AdminKiosk[]> {
    const { data } = await adminApi.get<ApiEnvelope<AdminKiosk[]>>(ENDPOINTS.admin.kioskCrud.list, {
      params: vendorId ? { vendor: vendorId } : undefined,
    });
    return data.data;
  },

  async create(payload: KioskPayload): Promise<AdminKiosk> {
    const { data } = await adminApi.post<ApiEnvelope<AdminKiosk>>(ENDPOINTS.admin.kioskCrud.list, payload);
    return data.data;
  },

  /** PATCH: send only the fields that changed. */
  async update(id: number, payload: Partial<KioskPayload>): Promise<AdminKiosk> {
    const { data } = await adminApi.patch<ApiEnvelope<AdminKiosk>>(
      ENDPOINTS.admin.kioskCrud.byId(id),
      payload,
    );
    return data.data;
  },

  async remove(id: number): Promise<void> {
    await adminApi.delete(ENDPOINTS.admin.kioskCrud.byId(id));
  },
};
